import PictureCardActions from './PictureCardActions'
export default PictureCardActions
